import { Component } from 'react'
import { connect } from 'react-redux'
import { TrackingHOC, OptionsHOC } from 'hocs'
import { selectCurrentPhone } from '../App/selectors'

class GoogleSearch extends Component {
  trackGoogleSeach = () => {
    const { device, query, createEvent } = this.props

    createEvent({
      category: 'search',
      data: {
        action: 'try_google',
        search_term: query,
        device_id: device ? device.id : null
      }
    })
  }

  googleQuery = () => {
    let { device, query } = this.props
    if (device) {
      query = `${device.manufacturer} ${device.name} ${query}`
    }
    return query
  }

  render() {
    const { query, getOption } = this.props
    const tryGoogle = getOption('search.tryGoogle', true)

    if (!tryGoogle || !query) {
      return null
    }

    return (
      <div>
        <span>Didn&apos;t find what you were looking for? </span>
        <a
          target="_blank"
          rel="noreferrer"
          href={`https://google.com/search?q=${this.googleQuery()}`}
          onClick={this.trackGoogleSeach}
        >
          Try google
        </a>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({ device: selectCurrentPhone(state) })

export default connect(mapStateToProps)(OptionsHOC(TrackingHOC(GoogleSearch)))
